import { Inventory } from '@cibo/core'
import { MenuItem } from '@mui/material'
import { StyledSelect } from '../StyledSelect'

export const BoundarySelector = ({
  value,
  onChange,
  inventory,
}: {
  value: string
  onChange(newValue: string): void
  inventory: Inventory
}) => {
  return (
    <StyledSelect
      disabled={inventory.boundaries.length < 2}
      value={value}
      onChange={({ target }) => onChange(target.value as string)}
      sx={{
        width: 250,
      }}
    >
      {inventory.boundaries.map(({ boundaryId, name }) => (
        <MenuItem key={boundaryId} value={boundaryId}>
          {name}
        </MenuItem>
      ))}
    </StyledSelect>
  )
}
